<div class="drag-handle" 
    [style.height]="node.dimension.height * BaseLength + 'px'"
    [style.width]="node.dimension.width * BaseLength + 'px'"
    >
    <button mat-icon-button class="delete-button" (click)="deleteNode()">
        <mat-icon>close</mat-icon>
    </button>
    <div class="full-height full-width">
        <ng-content></ng-content>
    </div>
</div>